var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRanking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8291 21.3206C3.8291 20.3541 4.6126 19.5706 5.5791 19.5706H20.7458C21.7123 19.5706 22.4958 20.3541 22.4958 21.3206V49.3206C22.4958 50.2871 21.7123 51.0706 20.7458 51.0706H5.5791C4.6126 51.0706 3.8291 50.2871 3.8291 49.3206V21.3206ZM7.3291 23.0706V47.5706H18.9958V23.0706H7.3291Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9958 7.32056C18.9958 6.35406 19.7793 5.57056 20.7458 5.57056H35.9124C36.8789 5.57056 37.6624 6.35406 37.6624 7.32056V49.3206C37.6624 50.2871 36.8789 51.0706 35.9124 51.0706H20.7458C19.7793 51.0706 18.9958 50.2871 18.9958 49.3206V7.32056ZM22.4958 9.07056V47.5706H34.1624V9.07056H22.4958Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1624 30.6539C34.1624 29.6874 34.9459 28.9039 35.9124 28.9039H51.0791C52.0456 28.9039 52.8291 29.6874 52.8291 30.6539V49.3206C52.8291 50.2871 52.0456 51.0706 51.0791 51.0706H35.9124C34.9459 51.0706 34.1624 50.2871 34.1624 49.3206V30.6539ZM37.6624 32.4039V47.5706H49.3291V32.4039H37.6624Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.2d41cfc5.svg";
export { ForwardRef as ReactComponent };